import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { adminUser } from '../models/adminUser';
import { appNotificationText } from '../models/appNotificationText';
import { emailNotificationText } from '../models/emailNotificationText';
import { smsNotificationText } from '../models/smsNotificationText';
import { login } from '../models/login';
import { forgotPassword } from '../models/forgetPassword';
import { role } from '../models/role';
import { pageContent } from '../models/pageContent';
import { banner } from '../models/banner';
import { userManagement } from '../models/userManagement';
import { emailVerificationStatus } from '../models/emailVerificationStatus';
import { vendor } from '../models/vendorManagement';
import { userAccount } from '../models/userAccountManagement';
import { currentInventory } from '../models/currentInventory';
import { shoppingCart } from '../models/shoppingCart';
import { savedList } from '../models/savedList';
import { mobileVerification } from '../models/mobileVerification';
import { category } from '../models/category';
import { subCategory } from '../models/subCategory';
import { reports } from '../models/reports';
  
@Injectable({
    providedIn: 'root'
  })
export class CucurachaAdminService {
  headers_object:any;
  userSession: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      "Authorization":JSON.parse(this.getToken())
    }),
    };
  
endpoint = 'http://35.154.239.192:4500/';
  // endpoint = 'http://localhost:4500/';
//endpoint = 'http://15.206.193.122:4500/';

  constructor(private hClient: HttpClient) {

  }
  getToken(){
    return localStorage.getItem('token')
  }
  sysLogAdd(id:any,token:any,device:any,browser:any): Observable<any> {
    return this.hClient.post(this.endpoint+'syslogadd/'+ id+'/'+token+'/'+device+'/'+browser, this.httpOptions);
  }
  logoutSysLog(token:any): Observable<any> {
    return this.hClient.post(this.endpoint+'logoutSysLog/'+token, this.httpOptions);
  }
  getSysLogs(): Observable<any> {
    return this.hClient.get(this.endpoint+'getsyslogs', { responseType: 'json' });
  }
  getMobileNumberStatus(username:any): Observable<any> {
    return this.hClient.get(this.endpoint+'getmobilenumberstatus/'+username, { responseType: 'json' });
  }
  /*******************Export logs */
  exportLogAdd(id:any,moduleName:any): Observable<any> {
    return this.hClient.post(this.endpoint+'exportlogadd/'+id+'/'+moduleName, this.httpOptions);
  }
  getExportLogs(): Observable<any> {
    return this.hClient.get(this.endpoint+'getexportlogs', { responseType: 'json' });
  }
  /***********************Verification Purpose************/
  verifyEmailAddressStatus(emailVerificationStatus:emailVerificationStatus): Observable<any> {
    console.log(emailVerificationStatus)

    return this.hClient.post(this.endpoint+'verifyEmailAddressStatusForSignIn/'+ emailVerificationStatus.emailId+'/'+emailVerificationStatus.OTP, this.httpOptions);
  }
  verifyEmailForEndUser(emailVerificationStatus:emailVerificationStatus): Observable<any> {
    console.log(emailVerificationStatus)

    return this.hClient.post(this.endpoint+'endusers/verifyEmailAddressStatus/'+ emailVerificationStatus.emailId+'/'+emailVerificationStatus.OTP, this.httpOptions);
  }
  verifyMobileNumber(mobileVerification:mobileVerification): Observable<any> {

    return this.hClient.post(this.endpoint+'verifymobilenumberstatusforsignin',mobileVerification,  this.httpOptions);
  }
  /************************************components***********************/

  sendMail(contact:any):Observable<any>{
    return this.hClient.post(this.endpoint+'forgototpthroughemail/'+ contact, this.httpOptions);
  }
  sendOtpSms(contact:any):Observable<any>{
    return this.hClient.post(this.endpoint+'forgototpthroughsms/'+ contact, this.httpOptions);
  }
  OtpVerification(otp:any,email:any):Observable<any>{
    return this.hClient.post(this.endpoint+'otpverification/'+otp+'/'+email, this.httpOptions);
  }
  otpVerificationWithMobileNumber(otp:any,mbl:any):Observable<any>{
    return this.hClient.post(this.endpoint+'otpverificationwithmobilenumber/'+otp+'/'+mbl, this.httpOptions);
  }
  getComponents():Observable<any>{
    return this.hClient.get(this.endpoint+'getcomponents', { responseType: 'json' });
  }
  savePermissions(obj:any): Observable<any> {
  
    
    return this.hClient.post(this.endpoint+'role_add', obj, this.httpOptions);
  
  }
  updatePermissions(obj:any): Observable<any> {
  
    console.log(obj)
    return this.hClient.post(this.endpoint+'role_update/'+obj._id, obj, this.httpOptions);
  
  }
  updateRolestatus(status:any,id:any,roleid:any): Observable<any> {
  
    return this.hClient.post(this.endpoint+'rolestatus_update/'+status+'/'+ id+'/'+roleid, this.httpOptions);
  
  }
  getAllRoles():Observable<any>{
    return this.hClient.get(this.endpoint+'getallroles', { responseType: 'json' });
  }
  getAllRolesforAdminUser():Observable<any>{
    return this.hClient.get(this.endpoint+'getallrolesforadmin', { responseType: 'json' });
  }
  getRoleById(id:any):Observable<any>{
    return this.hClient.get(this.endpoint+'getrole_byid/'+id, { responseType: 'json' });
  }
  deleteRoleById(id:any,roleid:any):Observable<any>{
    return this.hClient.delete(this.endpoint+'role_delete/'+roleid+'/'+id , { responseType: 'json' });
  }
  getallaccounts():Observable<any>{
    return this.hClient.get(this.endpoint+'endusers/getallaccounts' , { responseType: 'json' });
  }
  /**************************************UserProfile******************* */
  getUserDataByEmailId(email:any):Observable<any>{
    return this.hClient.get(this.endpoint+'getuserdata_byemailid/'+email, { responseType: 'json' });
  }
/**********************************Filter****************************** */
customizedFilterForAdminUsers(filter:any,value:any):Observable<any>{
  console.log(filter)
  return this.hClient.get(this.endpoint+'filters/customizedfilterforadminusers/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForRole(filter:any,value:any):Observable<any>{
  console.log(filter)
  return this.hClient.get(this.endpoint+'filters/customizedfilterforrole/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForUserAccounts(filter:any,value:any):Observable<any>{
  console.log(filter)
  return this.hClient.get(this.endpoint+'filters/customizedfilterforuseraccounts/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForUsers(filter:any,value:any):Observable<any>{
  console.log(filter)
  return this.hClient.get(this.endpoint+'filters/customizedfilterforusers/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForAccounts(filter:any,value:any):Observable<any>{
  console.log(filter)
  return this.hClient.get(this.endpoint+'filters/customizedfilterforaccounts/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForCurrentInventory(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterforcurrentinventory/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForShoppingCart(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterforshoppingcart/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForSavedList(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterforsavedlist/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForOpenOrders(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterforopenorders/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForOrderHistory(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterfororderhistory/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForVendors(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterforvendors/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForVendorsAccounts(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterforvendorAccounts/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForVendorsAccountProducts(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterforvendorAccountproducts/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForActiveOrders(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterforActiveOrders/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForCompletedOrders(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterforCompletedOrders/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForCancelledOrders(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterforCancelledOrders/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForBiddingDetails(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterforBidDetails/'+filter+'/'+value, { responseType: 'json' });
}
customizedFilterForGiveawayDetails(filter:any,value:any):Observable<any>{
  return this.hClient.get(this.endpoint+'filters/customizedfilterforGiveawayDetails/'+filter+'/'+value, { responseType: 'json' });
}
/**********************************Login*************************** */
Savelogin(login:login): Observable<any> {
  return this.hClient.post(this.endpoint+'Login/'+login.userName+'/'+login.passWord, { responseType: 'json' } );

}
passwordReset(forgotPassword:forgotPassword): Observable<any> {
  console.log(forgotPassword)
  return this.hClient.post(this.endpoint+'reset/'+forgotPassword.userName+'/'+forgotPassword.resetPassword, { responseType: 'json' } );

}
/******************************Admin Users******************************** */
verifyUserMobileData(mobileNumber:any):Observable<any>{
  return this.hClient.get(this.endpoint+'verifyUserMobileData/'+mobileNumber, { responseType: 'json' });
}
//post
saveAdminUser(adminUser:adminUser): Observable<any> {
  console.log(adminUser)

  
  return this.hClient.post(this.endpoint+'adminuser_add', adminUser, this.httpOptions);

}
//getAll
getallAdminUsers():Observable<any>{
  return this.hClient.get(this.endpoint+'getAlladminuser', { responseType: 'json' });
}
//delete
delteAdminUsers(id:any):Observable<any>{
  console.log(id)
  return this.hClient.delete(this.endpoint+'adminuser_delete/'+id, { responseType: 'json' });
}
//delete
deleteAccounts(id:any):Observable<any>{
  console.log(id)
  return this.hClient.delete(this.endpoint+'accountManagement/'+id, { responseType: 'json' });
}
//getBy(ID)
getByAdminId(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getadminuser_byid/'+id, { responseType: 'json' });
}
updateAdminUserstatus(adminUser:adminUser): Observable<any> {
  console.log(adminUser._id)
  return this.hClient.post(this.endpoint+'adminuserstatus_update/'+ adminUser._id, JSON.stringify(adminUser), this.httpOptions);
}
//update
updateAdminUser(adminUser:adminUser): Observable<any> {
  console.log(adminUser.id)
  return this.hClient.post(this.endpoint+'adminuser_update/'+ adminUser._id, JSON.stringify(adminUser), this.httpOptions);
}

/***************************************account management*************** */
getAllAccountsByStatus():Observable<any>{
  return this.hClient.get(this.endpoint+'getallaccountsbystatus', { responseType: 'json' });
}
/***********************************user Account******************* */
//get All
getAllUserAccounts():Observable<any>{
  return this.hClient.get(this.endpoint+'getuseraccounts', { responseType: 'json' });
}
getAllUserAccountsByStatus():Observable<any>{
  return this.hClient.get(this.endpoint+'getalluseraccountsbystatus', { responseType: 'json' });
}
getByUserAccountId(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getuseraccount_byid/'+id, { responseType: 'json' });
}
updateUserAccountStatus(userAccount:userAccount): Observable<any> {
  console.log(userAccount)
  return this.hClient.post(this.endpoint+'useraccountstatus_update/'+ userAccount._id, JSON.stringify(userAccount), this.httpOptions);
}
//delete
deleteuserAccount(id:any):Observable<any>{
  return this.hClient.delete(this.endpoint+'useraccounts_delete/'+id, { responseType: 'json' });
}
/***************************user management**********************/
//getAll
getAllUsers():Observable<any>{
  return this.hClient.get(this.endpoint+'getallusers', { responseType: 'json' });
}
// getAllUserAccountsByStatus():Observable<any>{
//   return this.hClient.get(this.endpoint+'getalluseraccountsbystatus', { responseType: 'json' });
// }
getByUserId(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getuser_byid/'+id, { responseType: 'json' });
}
updateUserStatus(userManagement:userManagement): Observable<any> {
  console.log(userManagement)
  return this.hClient.post(this.endpoint+'userstatus_update/'+ userManagement._id, JSON.stringify(userManagement), this.httpOptions);
}
//delete
deleteuser(id:any):Observable<any>{
  return this.hClient.delete(this.endpoint+'getusers_delete/'+id, { responseType: 'json' });
}


/*****************************appNotificationTextManagement************************** */

//post
saveAppNotificationTexts(appNotificationText:appNotificationText): Observable<any> {
  console.log(JSON.stringify(adminUser))
  return this.hClient.post(this.endpoint+'appnotificationtext_add', JSON.stringify(appNotificationText), this.httpOptions);

}
//getAll
getAllappNotificationTexts():Observable<any>{
  return this.hClient.get(this.endpoint+'getappnotificationtexts', { responseType: 'json' });
}
//get by id
getByAppNotificationTextId(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getappnotificationtext_byid/'+id, { responseType: 'json' });
}
//update
updateAppNotificationText(appNotificationText:appNotificationText): Observable<any> {
  return this.hClient.post(this.endpoint+'appnotificationtext_update/'+ appNotificationText._id, JSON.stringify(appNotificationText), this.httpOptions);
}
updateAppNotificationTextstatus(appNotificationText:appNotificationText): Observable<any> {
  return this.hClient.post(this.endpoint+'appnotificationtextstatus_update/'+ appNotificationText._id, JSON.stringify(appNotificationText), this.httpOptions);
}
//delete
deleteAppNotificationText(id:any):Observable<any>{
  return this.hClient.delete(this.endpoint+'appnotificationtext_delete/'+id, { responseType: 'json' });
}

/*****************************Email NotificationTextManagement************************** */

//post
saveEmailNotificationTexts(emailNotificationText:emailNotificationText): Observable<any> {
  console.log(JSON.stringify(adminUser))
  return this.hClient.post(this.endpoint+'emailnotificationtext_add', JSON.stringify(emailNotificationText), this.httpOptions);

}
//getAll
getAllEmailNotificationTexts():Observable<any>{
  return this.hClient.get(this.endpoint+'getemailnotificationtexts', { responseType: 'json' });
}
//get by id
getByEmailNotificationTextId(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getemailnotificationtext_byid/'+id, { responseType: 'json' });
}
//update
updateEmailNotificationText(emailNotificationText:emailNotificationText): Observable<any> {
  return this.hClient.post(this.endpoint+'emailnotificationtext_update/'+ emailNotificationText._id, JSON.stringify(emailNotificationText), this.httpOptions);
}
updateEmailNotificationTextstatus(appNotificationText:appNotificationText): Observable<any> {
  return this.hClient.post(this.endpoint+'emailnotificationtextstatus_update/'+ appNotificationText._id, JSON.stringify(appNotificationText), this.httpOptions);
}
//delete
deleteEmailNotificationText(id:any):Observable<any>{
  return this.hClient.delete(this.endpoint+'emailnotificationtext_delete/'+id, { responseType: 'json' });
}

/*****************************SMS NotificationTextManagement************************** */

//post
saveSmsNotificationTexts(smsNotificationText:smsNotificationText): Observable<any> {
  console.log(JSON.stringify(adminUser))
  return this.hClient.post(this.endpoint+'smsnotificationtext_add', JSON.stringify(smsNotificationText), this.httpOptions);

}
//getAll
getAllSmsNotificationTexts():Observable<any>{
  return this.hClient.get(this.endpoint+'getsmsnotificationtexts', { responseType: 'json' });
}
//get by id
getBySmsNotificationTextId(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getsmsnotificationtext_byid/'+id, { responseType: 'json' });
}
//update
updateSmsNotificationText(smsNotificationText:smsNotificationText): Observable<any> {
  return this.hClient.post(this.endpoint+'smsnotificationtext_update/'+ smsNotificationText._id, JSON.stringify(smsNotificationText), this.httpOptions);
}
updateSmsNotificationTextstatus(smsNotificationText:smsNotificationText): Observable<any> {
  return this.hClient.post(this.endpoint+'smsnotificationtextstatus_update/'+ smsNotificationText._id, JSON.stringify(smsNotificationText), this.httpOptions);
}
//delete
deleteSmsNotificationText(id:any):Observable<any>{
  return this.hClient.delete(this.endpoint+'smsnotificationtext_delete/'+id, { responseType: 'json' });
}

/**********************************************************ExcelTables*********** */
getallAdminUsersReport():Observable<any>{
  return this.hClient.get(this.endpoint+'excel/getadminuserReport', { responseType: 'json' });
}
/****************************************Page content******************************** */
savePageContent(pageContent:pageContent): Observable<any> {
  return this.hClient.post(this.endpoint+'pageContent_add', JSON.stringify(pageContent), this.httpOptions);

}
getAllPageContent():Observable<any>{
  return this.hClient.get(this.endpoint+'getallpagecontents', { responseType: 'json' });
}
getPageContentById(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getpagecontent_byid/'+id, { responseType: 'json' });
}
updatePageContent(pageContent:pageContent): Observable<any> {
  return this.hClient.post(this.endpoint+'pageContent_update/'+pageContent._id, JSON.stringify(pageContent), this.httpOptions);

}
/********************************************Banner ***************/
saveBanner(banner:banner): Observable<any> {
  return this.hClient.post(this.endpoint+'banner_add', JSON.stringify(banner), this.httpOptions);

}
getAllBanners():Observable<any>{
  return this.hClient.get(this.endpoint+'getallbanners', { responseType: 'json' });
}
getBannerById(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getbanner_byid/'+id, { responseType: 'json' });
}
updateBanner(banner:banner): Observable<any> {
  return this.hClient.post(this.endpoint+'banner_update/'+banner._id, JSON.stringify(banner), this.httpOptions);

}
updateBannerStatus(banner:banner): Observable<any> {
  return this.hClient.post(this.endpoint+'bannerstatus_update/'+ banner._id, JSON.stringify(banner), this.httpOptions);
}
deleteByBannerId(id:any):Observable<any>{
  return this.hClient.delete(this.endpoint+'banner_delete/'+id, { responseType: 'json' });
}
/***********************************current inventory********************/
saveCurrentInventory(currentInventory:currentInventory): Observable<any> {
  return this.hClient.post(this.endpoint+'currentInventory_add', JSON.stringify(currentInventory), this.httpOptions);

}
getAllcurrentInventory():Observable<any>{
  return this.hClient.get(this.endpoint+'getallproducts', { responseType: 'json' });
}
getByCurrentInventoryId(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getcurrentinventory_byid/'+id, { responseType: 'json' });
}
getByCurrentInventoryStatusandEmailID(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getcurrentinventory_bystatusemail/'+id, { responseType: 'json' });
}
updateCurrentInventoryStatus(currentInventory:currentInventory): Observable<any> {
  return this.hClient.post(this.endpoint+'currentInventorystatus_update/'+currentInventory._id, JSON.stringify(currentInventory), this.httpOptions);
}
updateCurrentInventory(currentInventory:currentInventory): Observable<any> {
  return this.hClient.post(this.endpoint+'currentInventory_update', JSON.stringify(currentInventory), this.httpOptions);

}
updateCurrentInventoryProductStatus(currentInventory:currentInventory): Observable<any> {
  return this.hClient.post(this.endpoint+'currentinventory/updateStatusDetails', JSON.stringify(currentInventory), this.httpOptions);

}
deletedByExpiryDate(expiry:any): Observable<any> {
  return this.hClient.post(this.endpoint+'currentInventory_updatebyexpirydate/'+expiry, this.httpOptions);

}
deleteCurrentInventoryById(id:any): Observable<any> {
  return this.hClient.post(this.endpoint+'currentInventory_updatestatusdelete/'+id, this.httpOptions);

}
/***********************************open orders********************/
saveOpenOrders(sid:any):Observable<any>{
  return this.hClient.post(this.endpoint+'openorders_add/'+sid, this.httpOptions);

}
getAllOpenOrders():Observable<any>{
  return this.hClient.get(this.endpoint+'getallopenorders', { responseType: 'json' });
}
getAllProductDetailsByOrderId(id):Observable<any>{
  return this.hClient.get(this.endpoint+'getallorderedproductsbyid/'+id, { responseType: 'json' });
}
getAllProductDetailsByOrderIdInOrdersList(id):Observable<any>{
  return this.hClient.get(this.endpoint+'getallorderedproductsbyidinorderslist/'+id, { responseType: 'json' });
}
/***********************************Saved List********************/
saveSavedList(savedList:savedList): Observable<any> {
  return this.hClient.post(this.endpoint+'savedlist_add', JSON.stringify(savedList), this.httpOptions);

}
getBySavedListId(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getsavedlist_byid/'+id, { responseType: 'json' });
}
getBySavedListStatus():Observable<any>{
  return this.hClient.get(this.endpoint+'getsavedlist_bystatus', { responseType: 'json' });
}
deleteSavedList(id:any): Observable<any> {
  return this.hClient.delete(this.endpoint+'savedlist_delete/'+id, { responseType: 'json' });
}
updateSavedList(savedList:savedList): Observable<any> {
  return this.hClient.post(this.endpoint+'savedlist_update', JSON.stringify(savedList), this.httpOptions);

}
getAllSavedListManagement():Observable<any>{
  return this.hClient.get(this.endpoint+'getallsavedlistmanagement', { responseType: 'json' });
}
/***********************************Vendor********************/
saveVendor(vendor:vendor): Observable<any> {
  return this.hClient.post(this.endpoint+'vendor_add', JSON.stringify(vendor), this.httpOptions);

}
getAllVendorMatersManagement():Observable<any>{
  return this.hClient.get(this.endpoint+'getallvendormastermanagement', { responseType: 'json' });
}
getByVendorId(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getvendor_byid/'+id, { responseType: 'json' });
}
getByVendorStatus(accountId:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getallvendormastermanagement_by_accountid/'+accountId, { responseType: 'json' });
}
updateVendorStatus(vendor:vendor): Observable<any> {
  console.log(vendor)
  return this.hClient.post(this.endpoint+'vendorstatus_update/'+vendor._id, JSON.stringify(vendor), this.httpOptions);
}
updateVendor(vendor:vendor): Observable<any> {
  return this.hClient.post(this.endpoint+'vendor_update', JSON.stringify(vendor), this.httpOptions);

}
/***********************************Shopping Cart********************/
saveShoppingCart(shoppingCart:shoppingCart): Observable<any> {
  return this.hClient.post(this.endpoint+'shoppingcart_add', JSON.stringify(shoppingCart), this.httpOptions);

}
getByShoppingCartId(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getshoppingcart_byid/'+id, { responseType: 'json' });
}
getByShoppingCartStatus():Observable<any>{
  return this.hClient.get(this.endpoint+'getshoppingcart_bystatus', { responseType: 'json' });
}
deleteShoppingCart(id:any): Observable<any> {
  return this.hClient.delete(this.endpoint+'shoppingcart_delete/'+id, { responseType: 'json' });
}
updateShoppingCart(shoppingCart:shoppingCart): Observable<any> {
  return this.hClient.post(this.endpoint+'shoppingcart_update', JSON.stringify(shoppingCart), this.httpOptions);

}
getAllShoppingCartManagement():Observable<any>{
  return this.hClient.get(this.endpoint+'getallshoppingcartmanagement', { responseType: 'json' });
}
/***********************************Order History********************/
getAllOrderHistoryManagement():Observable<any>{
  return this.hClient.get(this.endpoint+'getallorderhistorymanagement', { responseType: 'json' });
}
/**************************************DashBoard************************ */
getAllUsersCount():Observable<any>{
  return this.hClient.get(this.endpoint+'getallusers_count', { responseType: 'json' });
}
getAllAccountsCount():Observable<any>{
  return this.hClient.get(this.endpoint+'getallaccounts_count', { responseType: 'json' });
}
getAllProductsCount():Observable<any>{
  return this.hClient.get(this.endpoint+'getallproducts_count', { responseType: 'json' });
}
getAllVendorsCount():Observable<any>{
  return this.hClient.get(this.endpoint+'getallvendors_count', { responseType: 'json' });
}

/***********************************category********************/
//post
saveCategory(category:category): Observable<any> {
  return this.hClient.post(this.endpoint+'category_add', JSON.stringify(category), this.httpOptions);

}
//getAll
getAllCategory():Observable<any>{
  return this.hClient.get(this.endpoint+'getallcategories', { responseType: 'json' });
}

//get by id
getCategoryById(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getcategory_byid/'+id, { responseType: 'json' });
}
//update
updateCategory(category:category): Observable<any> {
  return this.hClient.post(this.endpoint+'category_update', JSON.stringify(category), this.httpOptions);
}
updateCategoryStatus(category:category): Observable<any> {
  return this.hClient.post(this.endpoint+'categorystatus_update/'+ category._id, JSON.stringify(category), this.httpOptions);
}
//delete
deleteCategory(id:any):Observable<any>{
  return this.hClient.delete(this.endpoint+'category_delete/'+id, { responseType: 'json' });
}
/***********************************Sub category********************/
//post
saveSubCategory(subCategory:subCategory): Observable<any> {
  return this.hClient.post(this.endpoint+'subcategory_add', JSON.stringify(subCategory), this.httpOptions);

}
//getAll
getAllSubCategory():Observable<any>{
  return this.hClient.get(this.endpoint+'getallsubcategories', { responseType: 'json' });
}
//get by id
getSubCategoryById(id:any):Observable<any>{
  return this.hClient.get(this.endpoint+'getsubcategory_byid/'+id, { responseType: 'json' });
}
getSubCategoryByCategoryId(id):Observable<any>{
  return this.hClient.get(this.endpoint+'getsubcategory_bycategoryid/'+id, { responseType: 'json' });
}
//update
updateSubCategory(subCategory:subCategory): Observable<any> {
  return this.hClient.post(this.endpoint+'subcategory_update', JSON.stringify(subCategory), this.httpOptions);
}
updateSubCategoryStatus(subCategory:subCategory): Observable<any> {
  return this.hClient.post(this.endpoint+'subcategorystatus_update/'+ subCategory._id, JSON.stringify(subCategory), this.httpOptions);
}
//delete
deleteSubCategory(id:any):Observable<any>{
  return this.hClient.delete(this.endpoint+'subcategory_delete/'+id, { responseType: 'json' });
}
/******************************************Chnage Password*************************/
changePassword(forgotPassword:forgotPassword): Observable<any> {
  return this.hClient.post(this.endpoint+'changepassword', JSON.stringify(forgotPassword), this.httpOptions);

}
/*********************** getAllVendorAccounts********************************/
getAllVendorAccounts():Observable<any>{
  return this.hClient.get(this.endpoint+'vendorUsers/getallvendoraccounts', { responseType: 'json' });
}
/***********************************updateKycStatus */
updateKycStatus(id:any,status:any): Observable<any> {
  return this.hClient.post(this.endpoint+'vendorUsers/kycStatusUpdate/'+ id+'/'+status, this.httpOptions);
}
//delete
deleteVendorAccount(id:any):Observable<any>{
  return this.hClient.delete(this.endpoint+'vendorUsers/vendorAccountDelete/'+id, { responseType: 'json' });
}
/***********************************update vendor Status */
updateVendorAccountStatus(id:any,status:any): Observable<any> {
  return this.hClient.post(this.endpoint+'vendorUsers/vendorAccountStatusUpdate/'+ id+'/'+status, this.httpOptions);
}
/*********************** getAllVendorAccounts********************************/
getVendorProducts():Observable<any>{
  return this.hClient.get(this.endpoint+'vendorUsers/getallAccountsVendorproducts', { responseType: 'json' });
}
/*****************************get All Cancelled Orders **************/
getAllCancelledOrders():Observable<any>{
  return this.hClient.get(this.endpoint+'vendorUsers/getAllCancelledOrders',{responseType:'json'});
}

/*****************************get All Active Completed orders **********/
getAllActiveCompletedorders():Observable<any>{
return this.hClient.get(this.endpoint+'vendorUsers/getAllActiveCompletedorders',{responseType:'json'});
}

/*****************************get All Accounts Active Orders **************/
getAllAccountsActiveOrders():Observable<any>{
  return this.hClient.get(this.endpoint+'vendorUsers/getAllAccountsActiveOrders',{responseType:'json'});
}

/************************get Product Details *******************/
getProductsDetailsByhistoryId(orderId:any,status:any):Observable<any>{
  return this.hClient.get(this.endpoint+'vendorUsers/getProductsDetailsByhistoryId/'+orderId+'/'+status,{responseType:'json'});
}

/************************get Bidding Details *******************/
getBiddingDetails():Observable<any>{
  return this.hClient.get(this.endpoint+'getBidDetails',{responseType:'json'});
}
getAllgiveAwayDetails():Observable<any>{
  return this.hClient.get(this.endpoint+'getAllgiveAwayDetails',{responseType:'json'});
}
/**************************************Reports************************* */
getAllDemandForcast(reports:reports): Observable<any> {
  return this.hClient.post(this.endpoint+'adminReports/getDemandForcast', JSON.stringify(reports), this.httpOptions);
}
getAllDemandForcastPeriodVsPeriod(reports:reports): Observable<any> {
  return this.hClient.post(this.endpoint+'adminReports/getDemandForcast/periodVsPeriod', JSON.stringify(reports), this.httpOptions);
}

getAllHistoricalConsumption(reports:reports): Observable<any> {
  return this.hClient.post(this.endpoint+'adminReports/getHistoricalConsumption', JSON.stringify(reports), this.httpOptions);
}
getAllHistoricalConsumptionPeriodVsPeriod(reports:reports): Observable<any> {
  return this.hClient.post(this.endpoint+'adminReports/getHistoricalConsumption/periodVsPeriod', JSON.stringify(reports), this.httpOptions);
}
getAllHistoricalWastage(reports:reports): Observable<any> {
  return this.hClient.post(this.endpoint+'adminReports/getHistoricalWastage', JSON.stringify(reports), this.httpOptions);
}
getAllHistoricalWastagePeriodVsPeriod(reports:reports): Observable<any> {
  return this.hClient.post(this.endpoint+'adminReports/getHistoricalWastage/periodVsPeriod', JSON.stringify(reports), this.httpOptions);
}
}